import { CompanyName } from '../Constants';
// Gallery images
import IMG1 from '../../assets/images/main/IMG_20250606_023858_578.jpg';
import IMG2 from '../../assets/images/main/IMG_20250606_023916_293.jpg';
import IMG3 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-vibrant-ass.jpg';
import IMG5 from '../../assets/images/main/IMG_20250606_023928_045.jpg';
import IMG7 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits.jpg';
import IMG8 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-amazig-lingerie.jpg';
import IMG9 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-amazing.jpg';
import IMG12 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-ass-and-hot.jpg';
import IMG14 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-big-ass-with-whip.jpg';
import IMG15 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-boot-crush.jpg';
import IMG16 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-ass-and-hot-red-horns.jpg';
import IMG18 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-shhh.jpg';
import IMG19 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-spikey-helm.jpg';

// Small gallery
import SmGallery1 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits.jpg';
import SmGallery2 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-shhh.jpg';
import SmGallery3 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-spikey-helm.jpg';
import SmGallery4 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-amazing.jpg';
import SmGallery5 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-ass-and-hot.jpg';
import SmGallery6 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-big-ass-with-whip.jpg';
import SmGallery7 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-amazig-lingerie.jpg';
import SmGallery8 from '../../assets/images/main/IMG_20250606_023916_293.jpg';

export const galleryImagesArray = [
  { src: IMG1, alt: `${CompanyName} Gallery Image 1`, name: 'Gallery Image 1', date: 'June 6, 2025' },
  { src: IMG2, alt: `${CompanyName} Gallery Image 2`, name: 'Gallery Image 2', date: 'June 6, 2025' },
  { src: IMG3, alt: `${CompanyName} Gallery Image 3`, name: 'Gallery Image 3', date: 'June 6, 2025' },
  { src: IMG5, alt: `${CompanyName} Gallery Image 5`, name: 'Gallery Image 5', date: 'June 6, 2025' },
  { src: IMG7, alt: `${CompanyName} Ebony Queen`, name: 'Ebony Queen', date: 'June 6, 2025' },
  { src: IMG8, alt: `${CompanyName} Lingerie`, name: 'Lingerie', date: 'June 6, 2025' },
  { src: IMG9, alt: `${CompanyName} Amazing`, name: 'Amazing', date: 'June 6, 2025' },
  { src: IMG12, alt: `${CompanyName} Big Ass`, name: 'Big Ass', date: 'June 6, 2025' },
  { src: IMG14, alt: `${CompanyName} Whip`, name: 'Whip', date: 'June 6, 2025' },
  { src: IMG15, alt: `${CompanyName} Boot Crush`, name: 'Boot Crush', date: 'June 6, 2025' },
  { src: IMG16, alt: `${CompanyName} Devil Pose`, name: 'Devil Pose', date: 'June 6, 2025' },
  { src: IMG18, alt: `${CompanyName} Shhh`, name: 'Shhh', date: 'June 6, 2025' },
  { src: IMG19, alt: `${CompanyName} Spikey Helm`, name: 'Spikey Helm', date: 'June 6, 2025' },
];


export const smallGalleryImagesArray = [
  {
    src: SmGallery1,
    name: 'Ebony Queen',
    alt: `${CompanyName} in command`,
    ariaLabel: 'Gallery image 1',
  },
  {
    src: SmGallery2,
    name: 'Shhh',
    alt: `${CompanyName} silences you`,
    ariaLabel: 'Gallery image 2',
  },
  {
    src: SmGallery3,
    name: 'Spiked Helm',
    alt: `${CompanyName} in her spiked helm`,
    ariaLabel: 'Gallery image 3',
  },
  {
    src: SmGallery4,
    name: 'Ebony Queen',
    alt: `${CompanyName} reigns`,
    ariaLabel: 'Gallery image 4',
  },
  {
    src: SmGallery5,
    name: 'Shhh Again',
    alt: `${CompanyName} keeps secrets`,
    ariaLabel: 'Gallery image 5',
  },
  {
    src: SmGallery6,
    name: 'Helm Redux',
    alt: `${CompanyName} in armor`,
    ariaLabel: 'Gallery image 6',
  },
  {
    src: SmGallery7,
    name: 'Lingerie Queen',
    alt: `${CompanyName} in amazing lingerie`,
    ariaLabel: 'Gallery image 7',
  },
  {
    src: SmGallery8,
    name: 'Worship',
    alt: `${CompanyName} being worshipped`,
    ariaLabel: 'Gallery image 8',
  },
];
